import React, { useState } from 'react'
import { FaChevronDown } from 'react-icons/fa'
import styles from './collapsibleSection.module.scss'

interface CollapsibleSectionProps {
    title: React.ReactNode
    hint?: React.ReactNode
    count?: React.ReactNode
    /** Controls rendered beside the toggle. Kept outside the button so they stay clickable. */
    actions?: React.ReactNode
    defaultOpen?: boolean
    /** Skip the white body panel so children sit on the page background. */
    flush?: boolean
    /** Keep the body visible, for example while an inline form is open. */
    forceOpen?: boolean
    children: React.ReactNode
}

export const CollapsibleSection = ({
    title,
    hint,
    count,
    actions,
    defaultOpen = true,
    flush = false,
    forceOpen = false,
    children,
}: CollapsibleSectionProps) => {
    const [open, setOpen] = useState(defaultOpen)
    const shown = forceOpen || open

    return (
        <section className={`${styles.section} ${shown ? styles.expanded : ''} ${flush ? styles.flush : ''}`}>
            <div className={styles.header}>
                <button
                    type="button"
                    className={styles.toggle}
                    onClick={() => setOpen((current) => !current)}
                    aria-expanded={shown}
                >
                    <FaChevronDown className={`${styles.chevron} ${shown ? styles.chevronOpen : ''}`} />
                    <span className={styles.titleRow}>
                        <span className={styles.title}>{title}</span>
                        {count !== undefined && count !== null && <span className={styles.count}>{count}</span>}
                    </span>
                </button>
                {actions && <div className={styles.actions}>{actions}</div>}
            </div>

            {shown && (
                <div className={styles.body}>
                    {hint && <p className={styles.hint}>{hint}</p>}
                    {children}
                </div>
            )}
        </section>
    )
}
